module.exports = __webpack_public_path__ + "static/google_tasks_1-e166dba7a4fb43200e2e9129baf393df.png";